import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';
import { CregresivaService } from 'src/app/services/cregresiva.service';

@Component({
  selector: 'app-lobby',
  templateUrl: './lobby.component.html',
  styleUrls: ['./lobby.component.css']
})
export class LobbyComponent implements OnInit {

  timing;
  public generalidades = [];
  ready;
  pic;
  urllive;
  titulo;
  situacion;
  fecha;
  hora;
  lobbyuse;

  /* basado en https://medium.com/angular-chile/angular-6-y-firestore-b7f270adcc96 */

  constructor(
    private router: Router, 
    private fireStore: FirestoreService, 
    public cregresiva: CregresivaService
  ) { 
    cregresiva.updateCountdown();
  }

  
  ngOnInit(): void {

    this.timing = this.cregresiva.value;

    this.fireStore.getCats()
      .subscribe((catsSnapshot) => {
      this.generalidades = [];
      catsSnapshot.forEach((catData: any, index, arreglo ) => {
        this.generalidades.push({
          id: catData.payload.doc.id,
          data: catData.payload.doc.data,
          pic: catData.payload.doc.data().pic,
          ready: catData.payload.doc.data().ready,
          situacion: catData.payload.doc.data().situacion,
          titulo: catData.payload.doc.data().titulo,
          urllive: catData.payload.doc.data().urllive,
          fecha: catData.payload.doc.data().fecha,
          hora: catData.payload.doc.data().hora,
          lobbyuse: catData.payload.doc.data().lobbyuse
        });

        this.pic = this.generalidades[0].pic;
        this.ready = this.generalidades[0].ready;
        this.situacion = this.generalidades[0].situacion;
        this.titulo = this.generalidades[0].titulo;
        this.urllive = this.generalidades[0].urllive;
        this.fecha = this.generalidades[0].fecha;
        this.hora = this.generalidades[0].hora;
        this.lobbyuse = this.generalidades[0].lobbyuse;

        console.log( `snapShot, ID:${catData.payload.doc.id}, index:${index}, arreglo:${arreglo}` );

        console.log( `ready: ${ this.generalidades[0].ready}, pic: ${ this.generalidades[0].fecha }, urllive: ${ this.generalidades[0].urllive }, titulo: ${ this.generalidades[0].titulo }` );
      
      })
    });

  }

}
